import { render, staticRenderFns } from "./AssignedStudentRow.vue?vue&type=template&id=2c7ad735&scoped=true"
import script from "./AssignedStudentRow.vue?vue&type=script&lang=js"
export * from "./AssignedStudentRow.vue?vue&type=script&lang=js"
import style0 from "./AssignedStudentRow.vue?vue&type=style&index=0&id=2c7ad735&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7ad735",
  null
  
)

export default component.exports